export default __webpack_public_path__ + "static/media/crm-banner.644b2b26.svg";